export default __webpack_public_path__ + "static/media/RotacionaKomoraHladnjakGrejac.d18b3199.png";